import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";

export function useWelderStatus(id: string, scope?: ScopeOfWork) {
  const filters = {
    wpsCode: scope?.wpsCode,
    continuityType: scope?.continuityType,
    reportDate: scope?.reportDate,
  };

  return useQuery(queryKeys.welder.status(id, filters), () => {
    return api.getWelderStatus(id, filters);
  });
}
